"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Loader_1 = require("./Loader");

function Form(_a) {
  var children = _a.children;
  return react_1["default"].createElement("form", {
    className: "mb-4"
  }, children);
}

exports.Form = Form;

Form.Netlify = function FormNetlify(_a) {
  var reference = _a.reference,
      name = _a.name,
      action = _a.action,
      children = _a.children;
  return react_1["default"].createElement("form", {
    ref: reference,
    name: name,
    action: action,
    "data-netlify": "true",
    "data-netlify-honeypot": "honeypot",
    className: "mb-4"
  }, react_1["default"].createElement("input", {
    type: "hidden",
    name: "form-name",
    value: name
  }), react_1["default"].createElement("input", {
    type: "text",
    className: "hidden",
    name: "honeypot"
  }), react_1["default"].createElement("input", {
    type: "hidden",
    name: "url",
    value: action
  }), children);
};

function Group(_a) {
  var children = _a.children;
  return react_1["default"].createElement("div", {
    className: "mb-6"
  }, children);
}

exports.Group = Group;

function Label(_a) {
  var htmlFor = _a["for"],
      children = _a.children;
  return react_1["default"].createElement("label", {
    className: "block text-gray-700 dark:text-white font-bold mb-2",
    id: htmlFor,
    htmlFor: htmlFor
  }, children);
}

exports.Label = Label;

function Input(_a) {
  var id = _a.id,
      type = _a.type,
      placeholder = _a.placeholder,
      onChangeText = _a.onChangeText,
      value = _a.value,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      _c = _a.loading,
      loading = _c === void 0 ? false : _c,
      className = _a.className,
      style = _a.style;
  return react_1["default"].createElement("div", {
    className: "relative"
  }, react_1["default"].createElement("input", {
    key: id,
    id: id,
    name: id,
    type: type || 'input',
    className: classnames_1["default"]('shadow appearance-none border dark:border-gray-700 rounded w-full py-2 px-3 text-gray-700 dark:text-white dark:bg-gray-800 leading-tight', {
      'focus:outline-none focus:shadow-outline': !disabled,
      'opacity-75 cursor-not-allowed': disabled,
      'pr-12': loading
    }, className),
    style: style,
    placeholder: placeholder || '',
    value: value,
    disabled: disabled,
    onChange: function onChange(e) {
      return onChangeText(e.target.value);
    }
  }), loading && react_1["default"].createElement(Loader_1.Loader, {
    className: "absolute -ml-8 border-primary dark:border-white",
    size: "xs",
    style: {
      top: 9
    }
  }));
}

exports.Input = Input;

function TextArea(_a) {
  var id = _a.id,
      placeholder = _a.placeholder,
      onChangeText = _a.onChangeText,
      value = _a.value,
      rows = _a.rows,
      disabled = _a.disabled,
      className = _a.className,
      style = _a.style;
  return react_1["default"].createElement("textarea", {
    key: id,
    name: id,
    id: id,
    rows: rows || 10,
    value: value,
    placeholder: placeholder || '',
    disabled: disabled,
    onChange: function onChange(e) {
      return onChangeText(e.target.value);
    },
    className: classnames_1["default"]('shadow appearance-none border dark:border-gray-700 rounded w-full py-2 px-3 text-gray-700 dark:text-white dark:bg-gray-800 leading-tight', {
      'focus:outline-none focus:shadow-outline': !disabled,
      'opacity-75 cursor-not-allowed': disabled
    }, className),
    style: style
  });
}

exports.TextArea = TextArea;

function Hint(_a) {
  var visible = _a.visible,
      message = _a.message;

  if (!visible) {
    return null;
  }

  return react_1["default"].createElement("p", {
    className: "mb-1 mt-2 text-gray-600 text-sm leading-tight"
  }, message);
}

exports.Hint = Hint;

function Error(_a) {
  var visible = _a.visible,
      message = _a.message;

  if (!visible) {
    return null;
  }

  return react_1["default"].createElement("p", {
    className: "mb-1 mt-2 text-red-700 text-sm leading-tight"
  }, message);
}

exports.Error = Error;

function Success(_a) {
  var visible = _a.visible,
      message = _a.message;

  if (!visible) {
    return null;
  }

  return react_1["default"].createElement("p", {
    className: "mb-1 mt-2 text-green-500 text-sm leading-tight"
  }, message);
}

exports.Success = Success;